
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/start-here/learning-launchpad/common-terminology-and-concepts",
      function () {
        return require("private-next-pages/docs/start-here/learning-launchpad/common-terminology-and-concepts/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/start-here/learning-launchpad/common-terminology-and-concepts"])
      });
    }
  